import isBreakElement from '../verifiers/is-break-element';
import findLastTextNode from './find-last-text-node';
import isMediaContainer from './is-media-container';

const getCollapsedSelectionForClipboard = (elements) => {
  let node = elements[elements.length - 1];

  if (isMediaContainer(node)) {
    return { node, offset: 0 };
  }

  node = findLastTextNode(node, true);

  if (!node) return null;
  if (isBreakElement(node)) return { node, offset: 0 };

  return { node, offset: node.data.length };
};

export default getCollapsedSelectionForClipboard;
